import React from 'react'
import { Switch, Route } from 'react-router-dom'
import ListsMapel from './ListsMapel'
import DetailMapel from './DetailMapel'
import ListsGuru from './ListsGuru'
import DetailGuru from './DetailGuru'
import ListsSiswa from './ListsSiswa'
import SiswaView from './SiswaView'
import FormPresensiSiswa from './FormPresensiSiswa'
import FormPresensiGuru from './FormPresensiGuru'
import EditPresensiSiswa from './FormEditPresensiSiswa'
import Analytics from 'react-router-ga'
import NotTaken from "./NotTaken";
import ExportSiswa from "./ExportSiswa";
import ExportGuru from "./ExportGuru";

const FormAdd = (props) => (
    <FormPresensiSiswa {...props} mode="Tambah" />
)

const FormAddGuru = (props) => (
    <FormPresensiGuru {...props} mode="Tambah" />
)
class ReportPresensi extends React.Component{

    render(){
        return(
            <div className="animated fadeIn">
                <div className="row">
                    <Analytics id="UA-123076872-5" debug>
                        <Switch>
                            <Route exact path={`${this.props.match.url}/nottaken`} component={ NotTaken }></Route>
                            <Route exact path={`${this.props.match.url}/siswa`} component={ ListsSiswa }></Route>
                            <Route exact path={`${this.props.match.url}/exportsiswa`} component={ ExportSiswa }></Route>
                            <Route exact path={`${this.props.match.url}/exportguru`} component={ ExportGuru }></Route>
                            <Route path={`${this.props.match.url}/siswa/add`} component={FormAdd}/>
                            <Route path={`${this.props.match.url}/guru/add`} component={FormAddGuru}/>
                            <Route path={`${this.props.match.url}/siswa/view/:user_id/:start/:end/edit/:presensi_id/:siswa_id`} component={EditPresensiSiswa}></Route>
                            <Route exact path={`${this.props.match.url}/guru`} component={ ListsGuru }></Route>
                            <Route path={`${this.props.match.url}/guru/view/:presensi_id/:start/:end`} component={ DetailGuru }></Route>
                            <Route exact path={`${this.props.match.url}/mapel`} component={ ListsMapel } ></Route>
                            <Route path={`${this.props.match.url}/mapel/view/:pg_id`} component={ DetailMapel }></Route>
                            <Route path={`${this.props.match.url}/siswa/view/:user_id/:start/:end`} component={ SiswaView } ></Route>
                        </Switch>
                    </Analytics>
                </div>
            </div>
        )
    }

}

export default ReportPresensi;


// WEBPACK FOOTER //
// ./src/views/ReportPresensi/index.js